import { render, staticRenderFns } from "./FirstSection.vue?vue&type=template&id=86aa6c62&scoped=true&"
import script from "./FirstSection.vue?vue&type=script&lang=ts&"
export * from "./FirstSection.vue?vue&type=script&lang=ts&"
import style0 from "./FirstSection.vue?vue&type=style&index=0&id=86aa6c62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86aa6c62",
  null
  
)

export default component.exports